import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=2bb4bcb6&scoped=true"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=2bb4bcb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4bcb6",
  null
  
)

export default component.exports